



import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "practice",
})
export default class Practice extends Vue {}
